import script from "./test.vue?vue&type=script&setup=true&lang=js"
export * from "./test.vue?vue&type=script&setup=true&lang=js"

import "./test.vue?vue&type=style&index=0&id=89c08036&lang=scss"
import "./test.vue?vue&type=style&index=1&id=89c08036&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89c08036"]])

export default __exports__